import * as angular from "angular";
import * as _ from "lodash";
import * as moment from "moment";
import {ResourceAllocationEditType} from "../../resources/types/resourceAllocationEdit.type";
import {ScheduleService} from "./schedule-service.service";
import {AgentScheduleExtraDataRequestType} from "../types/agent-schedule-extra-data-request.type";
import {AgentConfigurationProfilesRequestsService} from "../../configuration-profiles/services/agent-configuration-profiles-requests.service";
import {BatchRequestsService} from "../../batch/services/batch-requests.service";
import {AGENT_SCHEDULE_IMPORTER_PATH} from "../constants/agent-schedule-import.const";

export class ScheduleDialogService {

  constructor(private $mdDialog, private $q, private scheduleService: ScheduleService, private moment,
              private agentConfigurationProfilesRequestsService: AgentConfigurationProfilesRequestsService,
              private batchRequestsService: BatchRequestsService, private $log) {
  }

  create(event?, from?, to?, zoneId?) {
    const self = this;
    return this.$mdDialog.show({
      parent: angular.element(document.body),
      template: require('./../views/dialogs/create-schedule-dialog.html').default,
      controller: function ($scope, commonsConstants, splitService) {

        $scope.header = 'Create Shift';
        $scope.action = 'Create';

        $scope.rruleTypes = commonsConstants.rruleTypes;
        $scope.recurringType = undefined
        $scope.days = angular.copy(commonsConstants.daysCheckboxConfig);

        $scope.from = from ? moment(from).valueOf() : moment().startOf('day').valueOf();
        $scope.to = to ? moment(to).valueOf() : moment().endOf('day').set({
          'minute': 45,
          'second': 0,
          'millisecond': 0
        }).valueOf();
        $scope.zoneId = zoneId;

        $scope.scheduleCopy = {
          name: undefined,
          schedule: self.scheduleService.getSchedulePayload(
            $scope.from,
            $scope.to,
            undefined,
            undefined,
            'WEEKLY',
            undefined,
            zoneId)
        }

        $scope.cancel = self.$mdDialog.cancel;

        ///////////////////////////////////////////////////////////////

        // ******************************
        //        Public methods
        // ******************************

        $scope.submit = (form) => {
          if (form) {
            form.$setSubmitted(true);
            if (form.$valid) {

              const isWeekly = _.isEqual(_.get($scope.recurringType, 'value'), 'RRule.WEEKLY');
              const weekDays = isWeekly ? _.filter($scope.days, (value, key) => {
                return value.enabled;
              }) : [];

              $scope.scheduleCopy.schedule.zoneIdName = zoneId || splitService.getTimeZone();

              $scope.scheduleCopy.schedule.startTime = $scope.from;
              $scope.scheduleCopy.schedule.endTime = $scope.to;

              $scope.scheduleCopy.schedule.freq = $scope.recurringType?.value.substr(6);

              $scope.scheduleCopy.schedule.byWeekDay = _.map(weekDays, 'key');

              if ($scope.recurringType) {
                $scope.scheduleCopy.schedule.startRecurring = $scope.from;
              }

              self.$mdDialog.hide($scope.scheduleCopy);


            }

          }
        }

        $scope.onRecurringChange = (recurringType) => {
          $scope.recurringType = recurringType;

          if (recurringType.value === 'RRule.WEEKLY') {
            _setSelectedDay($scope.from);
          }
        }

        $scope.onRangeChange = (from, to) => {

          if (!_.isEqual($scope.from, from) && _.get($scope.recurringType, 'value') === 'RRule.WEEKLY') {
            _setSelectedDay(from);
          }

          $scope.from = from;
          $scope.to = to;
        }

        function _setSelectedDay(date) {
          if (!date) {
            return;
          }
          const selectedDay = moment(date).format('dd');
          if (selectedDay) {
            _.forOwn($scope.days, function (value, key) {
              value.enabled = _.isEqual(key, selectedDay);
            });
          }
        }

      },
      targetEvent: event,
      clickOutsideToClose: true
    })
  }

  edit(event?, schedule?, eventInstanceFromDate?, eventInstanceToDate?, zoneId?) {
    const self = this;
    return this.$mdDialog.show({
      parent: angular.element(document.body),
      template: require('./../views/dialogs/create-schedule-dialog.html').default,
      controller: function ($scope, commonsConstants, splitService) {
        const rruleTypes = commonsConstants.rruleTypes;

        const isRecurring = !!schedule?.templateId && !schedule.template && !schedule.overridden;
        $scope.isOriginalyRequrring = isRecurring;

        if (isRecurring && schedule.agentId) {
          self.scheduleService.getOneByAgentId(schedule.templateId, schedule.agentId)
            .then((template: any) => {
              $scope.recurringType = template.schedule?.freq ? _.find(commonsConstants.rruleTypes, (rt) => {
                return rt.type === template.schedule.freq;
              }) : undefined
            })
        } else {
          $scope.recurringType = schedule.schedule?.freq ? _.find(commonsConstants.rruleTypes, (rt) => {
            return rt.type === schedule.schedule.freq;
          }) : undefined
        }

        $scope.header = 'Update Shift';
        $scope.action = 'Update';
        $scope.isEdit = true;
        $scope.changeTypes = Object.values(ResourceAllocationEditType);
        $scope.resourceAllocationEditType = ResourceAllocationEditType;


        $scope.selectedChangeType = $scope.resourceAllocationEditType.EVENT;
        // # EVENT + long date
        // # FUTURE + long date
        // const ruleOptions = rrule.RRule.fromString(_.get(schedule, 'schedule.rrule', '')).origOptions;

        $scope.days = angular.copy(commonsConstants.daysCheckboxConfig);

        $scope.scheduleCopy = angular.copy(schedule);

        _.forEach($scope.scheduleCopy.schedule.byWeekDay, function (wd) {
          _.set($scope.days[wd], 'enabled', true);
        })

        $scope.from = moment(eventInstanceFromDate || $scope.scheduleCopy.schedule.startTime);
        $scope.to = moment(eventInstanceToDate || $scope.scheduleCopy.schedule.endTime);


        $scope.cancel = self.$mdDialog.cancel;
        ///////////////////////////////////////////////////////////////

        // ******************************
        //        Public methods
        // ******************************

        $scope.submit = (form) => {
          if (form) {
            form.$setSubmitted(true);
            if (form.$valid) {


              const isWeekly = _.isEqual(_.get($scope.recurringType, 'value'), 'RRule.WEEKLY');
              const weekDays = isWeekly ? _.filter($scope.days, function (value, key) {
                return value.enabled;
              }) : [];

              $scope.scheduleCopy.schedule.zoneIdName = zoneId || splitService.getTimeZone();

              $scope.scheduleCopy.schedule.startTime = $scope.from;
              $scope.scheduleCopy.schedule.endTime = $scope.to;

              $scope.scheduleCopy.schedule.freq = $scope.recurringType?.value.substr(6);

              $scope.scheduleCopy.schedule.byWeekDay = _.map(weekDays, 'key');

              // if ($scope.recurringType) {
              //     $scope.scheduleCopy.schedule.startRecurring = $scope.from;
              // }

              self.$mdDialog.hide({schedule: $scope.scheduleCopy, changeType: $scope.selectedChangeType});
            }

          }
        }

        $scope.onRecurringChange = (recurringType) => {
          $scope.recurringType = recurringType;

          if (recurringType === 'WEEKLY') {
            _setSelectedDay($scope.from);
          }

        }

        $scope.onRangeChange = (from, to) => {
          if (!_.isEqual($scope.from, from) && _.get($scope.recurringType, 'value') === 'RRule.WEEKLY') {
            _setSelectedDay(from);
          }

          $scope.from = from;
          $scope.to = to;
        }

        $scope.onSelectedTypeChange = (selectedType) => {
          $scope.selectedChangeType = selectedType;
        }

        function _setSelectedDay(date) {
          if (!date) {
            return;
          }
          var selectedDay = moment(date).format('dd');
          if (selectedDay) {
            _.forOwn($scope.days, function (value, key) {
              value.enabled = _.isEqual(key, selectedDay);
            });
          }
        }

      },
      targetEvent: event,
      clickOutsideToClose: true
    })
  }

  selectChangeType(event?, extraInfo?) {
    const self = this;
    return this.$mdDialog.show({
      parent: angular.element(document.body),
      template: require('./../views/dialogs/select-schedule-change-type-dialog.html').default,
      controller: function ($scope) {

        $scope.cancel = self.$mdDialog.cancel;

        $scope.types = Object.values(ResourceAllocationEditType);
        $scope.selectedType = $scope.types[0];


        $scope.extraInfo = extraInfo;
        ///////////////////////////////////////////////////////////////

        // ******************************
        //        Public methods
        // ******************************

        $scope.submit = (form) => {
          if (form) {
            form.$setSubmitted(true);
            if (form.$valid) {
              self.$mdDialog.hide($scope.selectedType);
            }

          }
        }

        $scope.onSelectedTypeChange = (selectedType) => {
          $scope.selectedType = selectedType;
        }

      },
      targetEvent: event,
      clickOutsideToClose: true
    })
  }

  duplicate(event, shift) {
    const self = this;
    return this.$mdDialog.show({
      parent: angular.element(document.body),
      template: require('./../views/dialogs/duplicate-schedule-dialog.html').default,
      controller: function ($scope, $mdSelect, commonsConstants) {

        const daysArray = commonsConstants.dayArray;

        $scope.shift = shift;
        $scope.selectedDays = [];
        $scope.days = _.filter(daysArray, function (d) {
          return d.substring(0, 2) !== $scope.shift.schedule.byWeekDay[0];
        });

        $scope.onReset = onReset;
        $scope.onSelect = onSelect;
        $scope.cancel = self.$mdDialog.cancel;

        //////////////////////////////////////////////////////////////

        function onReset() {
          $scope.selectedDays = [];
          $mdSelect.hide();
        }

        function onSelect() {
          $mdSelect.hide();
        }

        $scope.submit = (form) => {
          if (form) {
            form.$setSubmitted(true);
            if (form.$valid) {
              const shifts = _.map($scope.selectedDays, function (d) {
                const shiftCopy = angular.copy($scope.shift);

                // Reset Resources Shift Id
                // _.forEach(shiftCopy.supplyResourceList, function(resource) {
                //     _.unset(resource, 'shiftId');
                // });

                shiftCopy.schedule.startTime = _getTimeDateByDay(shiftCopy.schedule.startTime, d);
                shiftCopy.schedule.endTime = _getTimeDateByDay(shiftCopy.schedule.endTime, d);
                shiftCopy.schedule.byWeekDay = [d.substring(0, 2)];
                shiftCopy.createdAt = moment().valueOf();
                return shiftCopy;
              });
              self.$mdDialog.hide(shifts);

            }
          }
        }

        function _getTimeDateByDay(date, day) {
          return moment(date).day(day).valueOf();
        }

      },
      targetEvent: event,
      fullscreen: true,
      clickOutsideToClose: true
    })
  }

  addNote(event, note) {
    const self = this;
    return this.$mdDialog.show({
      parent: angular.element(document.body),
      template: require('./../views/dialogs/add-note-dialog.html').default,
      controller: function ($scope) {

        $scope.header = note ? 'Update Note' : 'Create a Note';

        $scope.note = note ? angular.copy(note) : {
          text: undefined
        }

        $scope.cancel = self.$mdDialog.cancel;

        //////////////////////////////////////////////////////////////

        $scope.submit = (form) => {
          if (form) {
            form.$setSubmitted(true);
            if (form.$valid) {
              self.$mdDialog.hide($scope.note);
            }
          }
        }


      },
      targetEvent: event,
      fullscreen: true,
      clickOutsideToClose: true
    })
  }

  updateShiftBreak(event, breakObject, isRecurring?, min?, max?) {
    const self = this;
    return this.$mdDialog.show({
      parent: angular.element(document.body),
      template: require('./../views/dialogs/add-break-dialog.html').default,
      controller: function ($scope, moment) {

        $scope.header = breakObject ? 'Update Break' : 'Create a Break';

        $scope.isRecurring = isRecurring;
        $scope.isRecurringEnabled = !!isRecurring;
        $scope.recurringType = AgentScheduleExtraDataRequestType.INDIVIDUAL;
        $scope.recurringTypes = [AgentScheduleExtraDataRequestType.INDIVIDUAL, AgentScheduleExtraDataRequestType.RECURRING, AgentScheduleExtraDataRequestType.REPEATED];

        $scope.start = breakObject ? breakObject.notBefore : min;
        $scope.end = breakObject ? breakObject.notBefore + breakObject.duration : max;
        $scope.repeatTo = undefined;
        $scope.minDate = min;
        $scope.maxDate = max;
        $scope.note = breakObject?.internalNote?.text;

        $scope.onRangeChanged = (notBefore, endDate) => {
          $scope.start = notBefore;
          $scope.end = endDate;
        }

        $scope.onChangeRecurringType = (recurringType) => {
          $scope.recurringType = recurringType;
          $scope.repeatTo = recurringType ===  AgentScheduleExtraDataRequestType.REPEATED ?
            angular.copy($scope.start) :
            undefined;
        }

        $scope.onToRepeatedDateChange = (date) => {
          $scope.repeatTo = moment(date).endOf('day').valueOf();
        }

        $scope.isInvalidDates = () => {
          return $scope.start >= $scope.end || $scope.end <= $scope.start;
        }

        $scope.cancel = self.$mdDialog.cancel;

        //////////////////////////////////////////////////////////////

        $scope.submit = (form) => {
          if (form) {
            form.$setSubmitted(true);
            if (form.$valid) {
              const breakCopy = !!$scope.break ? angular.copy($scope.break) : {};
              breakCopy.notBefore = $scope.start;
              breakCopy.notAfter = $scope.start;
              breakCopy.endDate = $scope.end;
              breakCopy.duration = moment.duration(moment($scope.end).diff(moment($scope.start))).asMilliseconds();

              // Hack for server that break will be 100% on shift
              if (min === breakCopy.notBefore) {
                breakCopy.notBefore = moment(breakCopy.notBefore).add(1, 'second').valueOf();
                breakCopy.notAfter = moment(breakCopy.notBefore).add(1, 'second').valueOf();
              }
              if (max === breakCopy.endDate) {
                breakCopy.endDate = moment(breakCopy.endDate).subtract(1, 'second').valueOf();
              }

              if (!!$scope.note) {
                if (!breakCopy.internalNote) {
                  breakCopy.internalNote = {};
                }
                breakCopy.internalNote.text = $scope.note;
              }

              breakCopy.note = $scope.note;

              const repeatFrom = AgentScheduleExtraDataRequestType.REPEATED ? $scope.start : undefined;
              const repeatTo = AgentScheduleExtraDataRequestType.REPEATED ? $scope.repeatTo : undefined;
              self.$mdDialog.hide({break: breakCopy, type: $scope.recurringType, repeatFrom: repeatFrom, repeatTo: repeatTo});
            }
          }
        }


      },
      targetEvent: event,
      fullscreen: true,
      clickOutsideToClose: true
    })
  }

  deleteShiftBreak(event, breakObject, isRecurring?) {
    const self = this;
    return this.$mdDialog.show({
      parent: angular.element(document.body),
      template: require('./../views/dialogs/delete-break-dialog.html').default,
      controller: function ($scope, moment) {

        $scope.isRecurring = isRecurring;
        $scope.isRecurringEnabled = !!isRecurring;
        $scope.recurringType = AgentScheduleExtraDataRequestType.INDIVIDUAL;
        $scope.recurringTypes = [AgentScheduleExtraDataRequestType.INDIVIDUAL, AgentScheduleExtraDataRequestType.RECURRING];

        $scope.onChangeRecurringType = (recurringType) => {
          $scope.recurringType = recurringType;
        }

        $scope.cancel = self.$mdDialog.cancel;

        //////////////////////////////////////////////////////////////

        $scope.submit = (form) => {
          if (form) {
            form.$setSubmitted(true);
            if (form.$valid) {
              self.$mdDialog.hide({break: {}, type: $scope.recurringType});
            }
          }
        }


      },
      targetEvent: event,
      fullscreen: true,
      clickOutsideToClose: true
    })
  }

  bulkEditBreaks(shifts, event?) {
    const self = this;
    return this.$mdDialog.show({
      parent: angular.element(document.body),
      template: require('./../views/dialogs/bulk-edit-agent-schedule-break-dialog.html').default,
      controller: function ($scope, moment) {
        $scope.shiftsCopy = angular.copy(shifts);
        $scope.maxTime;
        $scope.clockTicksInMinuts = 15;

        $scope.duplicateNote = undefined;
        $scope.duplicateBreak = {
          notBefore: self.moment().startOf('day').valueOf(),
          notAfter: self.moment().startOf('day').valueOf(),
          endDate: self.moment().endOf('day').minute(45).seconds(0).millisecond(0).valueOf()
        };
        $scope.minTime = self.moment().startOf('day').add($scope.clockTicksInMinuts, 'minutes').valueOf();
        $scope.maxTime = self.moment().endOf('day').minute(45).seconds(0).millisecond(0).subtract($scope.clockTicksInMinuts, 'minutes').valueOf()

        $scope.cancel = self.$mdDialog.cancel;

        //////////////////////////////////////////////////////////////

        $scope.onDeleteBreaks = () => {
          $scope.duplicateBreak = undefined;
          $scope.minDate = undefined;
          $scope.maxDate = undefined;
        }

        $scope.onDuplicateNote = (text) => {
          _.forOwn($scope.extraDataMapByAgent, (extraDataItemsPayload, key) => {
            _.forEach(extraDataItemsPayload, (payload) => {
              if (!payload.extraData.internalNote) {
                payload.extraData.internalNote = {};
              }
              payload.extraData.internalNote.text = text;
            })
          })
        }

        $scope.onNotBeforeTimeChange = (date) => {
          if (!$scope.duplicateBreak) {
            $scope.duplicateBreak = {};
          }
          _.set($scope.duplicateBreak, 'notBefore', date);
          _.set($scope.duplicateBreak, 'notAfter', date);
          $scope.minTime = self.moment(date).add($scope.clockTicksInMinuts, 'minutes').valueOf();
        }

        $scope.onEndDateTimeChange = (date) => {
          if (!$scope.duplicateBreak) {
            $scope.duplicateBreak = {};
          }
          _.set($scope.duplicateBreak, 'endDate', date);
          $scope.maxTime = self.moment(date).subtract($scope.clockTicksInMinuts, 'minutes').valueOf()
        }

        $scope.submit = (form) => {
          if (form) {
            form.$setSubmitted(true);
            if (form.$valid) {
              const scheduleExtraDataPayload = [];

              _.forEach($scope.shiftsCopy, (s) => {
                //base schedule data
                let scheduleData = {
                  agentId: _.get(s, 'agentId'),
                  eventDate: _.get(s, 'agentSchedule.schedule.startTime'),
                  scheduleId: _.get(s, 'agentSchedule.id')
                };

                let existingScheduleExtraData = _.find(s.scheduleExtraData, (ed: any) => {
                  return moment(moment(s.date).format("MM/DD/YYYY")).isSame(moment(ed.eventDate).format("MM/DD/YYYY"))
                })

                let updatedBreak;

                if ($scope.duplicateBreak) {
                  updatedBreak = {
                    notBefore: moment(scheduleData.eventDate).set('hour', moment($scope.duplicateBreak.notBefore).hour()).set('minute', moment($scope.duplicateBreak.notBefore).minute()).set('second', 0).valueOf(),
                    notAfter: moment(scheduleData.eventDate).set('hour', moment($scope.duplicateBreak.notBefore).hour()).set('minute', moment($scope.duplicateBreak.notBefore).minute()).set('second', 0).valueOf(),
                    endDate: moment(scheduleData.eventDate).set('hour', moment($scope.duplicateBreak.endDate).hour()).set('minute', moment($scope.duplicateBreak.endDate).minute()).set('second', 0).valueOf(),
                    duration: moment.duration(moment($scope.duplicateBreak.end).diff(moment($scope.duplicateBreak.start))).asMilliseconds()
                  }

                  // Hack for server that break will be 100% on shift
                  if (s.agentSchedule?.schedule?.startTime === updatedBreak.notBefore) {
                    updatedBreak.notBefore = moment(updatedBreak.notBefore).add(1, 'second').valueOf();
                    updatedBreak.notAfter = moment(updatedBreak.notBefore).add(1, 'second').valueOf();
                  }
                  if (s.agentSchedule?.schedule?.endTime === updatedBreak.endDate) {
                    updatedBreak.endDate = moment(updatedBreak.endDate).subtract(1, 'second').valueOf();
                  }

                  if (!!$scope.note) {
                    updatedBreak.internalNote = {
                      text: $scope.note
                    }
                  }

                  _.set(updatedBreak, 'duration', moment.duration(moment(updatedBreak.endDate).diff(moment(updatedBreak.notBefore))).asMilliseconds())
                }

                let extraData = {};

                if (existingScheduleExtraData) {
                  _.set(extraData, 'id', existingScheduleExtraData.id);
                  _.set(extraData, 'siteId', existingScheduleExtraData.siteId);
                  _.set(extraData, 'agentId', existingScheduleExtraData.agentId);
                  _.set(extraData, 'scheduleId', existingScheduleExtraData.scheduleId);
                  _.set(extraData, 'internalNote', existingScheduleExtraData.internalNote);
                  _.set(extraData, 'routeId', existingScheduleExtraData.routeId);
                  _.set(extraData, 'eventDate', existingScheduleExtraData.eventDate);
                  _.set(extraData, 'eventDate', existingScheduleExtraData.eventDate);
                  _.set(extraData, 'updatedAt', existingScheduleExtraData.updatedAt);
                  _.set(extraData, 'createdAt', existingScheduleExtraData.createdAt);
                  if (updatedBreak) {
                    _.set(updatedBreak, 'id', _.get(existingScheduleExtraData, 'breaks[0].id'));
                  }
                }
                _.set(extraData, 'breaks', updatedBreak ? [updatedBreak] : undefined);
                _.set(scheduleData, 'extraData', extraData);

                scheduleExtraDataPayload.push(scheduleData)
              })

              self.$mdDialog.hide(scheduleExtraDataPayload);
            }
          }
        }


      },
      targetEvent: event,
      fullscreen: true,
      clickOutsideToClose: true
    })
  }

  bulkEditNotes(shifts, event?) {
    const self = this;
    return this.$mdDialog.show({
      parent: angular.element(document.body),
      template: require('./../views/dialogs/bulk-edit-agent-schedule-note-dialog.html').default,
      controller: function ($scope, moment) {

        $scope.shiftsCopy = angular.copy(shifts);
        $scope.duplicateNote = shifts?.length === 1 ? _.get(shifts, '[0].agentSchedule.scheduleExtraData.internalNote.text') : undefined;

        $scope.cancel = self.$mdDialog.cancel;

        //////////////////////////////////////////////////////////////

        $scope.OnDeleteAndSubmit = (form) => {
          $scope.duplicateNote = undefined;
          $scope.submit(form);
        }

        $scope.submit = (form) => {
          if (form) {
            form.$setSubmitted(true);
            if (form.$valid) {
              const scheduleExtraDataPayload = [];

              _.forEach($scope.shiftsCopy, (s) => {
                //base schedule data
                let scheduleData = {
                  agentId: _.get(s, 'agentId'),
                  eventDate: _.get(s, 'agentSchedule.schedule.startTime'),
                  scheduleId: _.get(s, 'agentSchedule.id')
                };

                let existingScheduleExtraData = _.find(s.scheduleExtraData, (ed: any) => {
                  return moment(moment(s.date).format("MM/DD/YYYY")).isSame(moment(ed.eventDate).format("MM/DD/YYYY"))
                })

                let extraData = {};
                let internalNote = {};

                if (existingScheduleExtraData) {
                  _.set(extraData, 'id', existingScheduleExtraData.id);
                  _.set(extraData, 'siteId', existingScheduleExtraData.siteId);
                  _.set(extraData, 'agentId', existingScheduleExtraData.agentId);
                  _.set(extraData, 'scheduleId', existingScheduleExtraData.scheduleId);
                  _.set(extraData, 'routeId', existingScheduleExtraData.routeId);
                  _.set(extraData, 'eventDate', existingScheduleExtraData.eventDate);
                  _.set(extraData, 'updatedAt', existingScheduleExtraData.updatedAt);
                  _.set(extraData, 'createdAt', existingScheduleExtraData.createdAt);
                  _.set(extraData, 'breaks', existingScheduleExtraData.breaks);
                  internalNote = _.get(existingScheduleExtraData, 'internalNote', {});
                }

                if ($scope.duplicateNote) {
                  _.set(internalNote, 'text', $scope.duplicateNote);
                  _.set(extraData, 'internalNote', internalNote);
                }
                _.set(scheduleData, 'extraData', extraData);

                scheduleExtraDataPayload.push(scheduleData)
              })

              self.$mdDialog.hide(scheduleExtraDataPayload);
            }
          }
        }
      },
      targetEvent: event,
      fullscreen: true,
      clickOutsideToClose: true
    })
  }

  createTemplate(event?, template?) {
    const self = this;
    return this.$mdDialog.show({
      parent: angular.element(document.body),
      template: require('./../views/dialogs/create-schedule-template-dialog.html').default,
      controller: function ($scope, commonsConstants, moment, splitService) {

        $scope.header = template ? 'Update Template' : 'Create New Template';
        $scope.action = template ? 'Update' : 'Create';
        $scope.timeZones = moment.tz.names();
        $scope.configTimeZone = splitService.getTimeZone();
        $scope.template = template ? angular.copy(template) : {name: undefined, zoneId: $scope.configTimeZone};
        $scope.isDifferentTimeZone = !_.isEqual(_.get(template, 'zoneId'), $scope.configTimeZone);

        $scope.cancel = self.$mdDialog.cancel;
        ///////////////////////////////////////////////////////////////

        // ******************************
        //        Public methods
        // ******************************

        $scope.submit = (form) => {
          if (form) {
            form.$setSubmitted(true);
            if (form.$valid) {
              if (_.isUndefined(_.get($scope.template, 'zoneId'))) {
                $scope.template.zoneId = $scope.configTimeZone;
              }
              self.$mdDialog.hide($scope.template);
            }

          }
        }

      },
      targetEvent: event,
      fullscreen: true,
      clickOutsideToClose: true
    })
  }

  selectTemplate(event, selectedTemplate) {
    const self = this;
    return this.$mdDialog.show({
      parent: angular.element(document.body),
      template: require('./../views/dialogs/select-schedule-template-dialog.html').default,
      controller: function ($scope) {

        $scope.template = selectedTemplate;

        $scope.onSelectTemplate = onSelectTemplate;
        $scope.cancel = self.$mdDialog.cancel;
        ///////////////////////////////////////////////////////////////

        // ******************************
        //        Public methods
        // ******************************

        function onSelectTemplate(template) {
          $scope.template = template;
        }

        $scope.submit = (form) => {
          if (form) {
            form.$setSubmitted(true);
            if (form.$valid) {
              self.$mdDialog.hide($scope.template);
            }

          }
        }

      },
      targetEvent: event,
      clickOutsideToClose: true
    })
  }

  /**
   * "Upload Agent Schedules" modal. Resolves with the validated rows (ImportVerification[])
   * returned by /importers-agent-schedules/upload so the caller can review them before
   * committing the import.
   */
  showUploadAgentSchedulesDialog(event: Event, schemas?: any[]) {
    const self = this;
    return this.$mdDialog.show({
      templateUrl: 'app/modules/schedule/views/dialogs/upload-agent-schedules-dialog.html',
      parent: angular.element(document.body),
      targetEvent: event,
      clickOutsideToClose: false,
      fullscreen: true,
      controller: function ($scope) {
        $scope.loading = false;
        $scope.file = undefined;
        $scope.schemaId = undefined;
        $scope.isFileMissing = false;
        $scope.isUploadFailed = false;
        $scope.schemaOptionsWrapper = {
          list: (schemas || []).map((schema) => {
            return {id: schema.id, name: schema.schemaName};
          }),
          propertyRef: 'name'
        };

        $scope.cancel = self.$mdDialog.cancel;

        $scope.onSelectSchema = (schemaId) => {
          $scope.schemaId = schemaId;
          $scope.isFileMissing = false;
          $scope.isUploadFailed = false;
        };

        $scope.onAddFile = (file) => {
          $scope.file = file;
          $scope.isFileMissing = false;
          $scope.isUploadFailed = false;
        };

        $scope.onUpload = () => {
          if (!$scope.file) {
            $scope.isFileMissing = true;
            return;
          }

          $scope.loading = true;

          self.batchRequestsService.uploadAgentSchedules(AGENT_SCHEDULE_IMPORTER_PATH, $scope.file, $scope.schemaId)
            .then((rows: any) => {
              self.$mdDialog.hide(rows || []);
            })
            .catch((error) => {
              $scope.isUploadFailed = true;
              self.$log.error('Failed to validate agent schedules excel, ' +
                'scheduleDialogService@showUploadAgentSchedulesDialog', error);
            })
            .finally(() => {
              $scope.loading = false;
            });
        };
      }
    });
  }

  handleConflictError(error, agentId, schedule?) {
    const isConflict = error?.status === 409;
    if (!isConflict) {
      return this.$q.resolve(null);
    }
    const conflictIds = _.flatMap(error?.data, (validationError) => _.get(validationError, 'details.conflictIds', []));
    if (!conflictIds.length) {
      return this.$q.resolve(null);
    }
    const isCreateFlow = !!schedule;
    return this.$q.all({
      schedules: this.scheduleService.getManyByIds(conflictIds, agentId),
      profile: isCreateFlow ? this.agentConfigurationProfilesRequestsService.getConfigurationByAgent(agentId).catch(() => null) : this.$q.resolve(null)
    }).then(({schedules, profile}) => {
      const canIgnore = isCreateFlow && !!_.get(profile, 'shiftRestrictions.agentRecordRestrictionPreferences.overlapSettings.allowAvailabilityVsAvailability', false);
      return this.showConflictDialog(undefined, schedules, {isCreateFlow, canIgnore}).then((result) => {
        return result === 'ignore' ? this.scheduleService.createManyByAgentIdIgnoringConflicts(schedule, agentId) : null;
      });
    });
  }

  showConflictDialog(event, schedules, {isCreateFlow, canIgnore}: {isCreateFlow?: boolean, canIgnore?: boolean} = {}) {
    const self = this;
    const decoratedSchedules = _.map(schedules, (item) => {
      // The byIds endpoint returns schedule templates flat, but instances still wrapped under `agentSchedule`.
      const agentSchedule = item?.agentSchedule || item;
      const rawExtraData = agentSchedule?.scheduleExtraData ?? item?.scheduleExtraData;
      const extraData = _.isArray(rawExtraData) ? rawExtraData[0] : rawExtraData;
      return {
        ...agentSchedule,
        recurringInfo: this.scheduleService.getRecurringInfo(agentSchedule),
        routeIds: extraData?.routeIds || []
      };
    });
    return this.$mdDialog.show({
      parent: angular.element(document.body),
      template: require('./../views/dialogs/conflict-warning-dialog.html').default,
      controller: function ($scope) {
        $scope.schedules = decoratedSchedules;
        $scope.isCreateFlow = !!isCreateFlow;
        $scope.showIgnoreButton = !!isCreateFlow && !!canIgnore;
        $scope.cancel = () => self.$mdDialog.cancel();
        $scope.submit = () => self.$mdDialog.hide();
        $scope.ignore = () => self.$mdDialog.hide('ignore');
      },
      targetEvent: event,
      clickOutsideToClose: true
    }).catch(() => null);
  }
}

angular
  .module('bringoz.admin.schedule')
  .service('scheduleDialogService', ScheduleDialogService);
